
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobfeed",
      function () {
        return require("private-next-pages/jobfeed/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobfeed"])
      });
    }
  